import {
  RelationContextType,
  RelationOption,
} from '@components/EntityDrawers/drawers/Relationship/constants/types';
import { RelationshipFormValues } from '@components/EntityDrawers/drawers/Relationship/form';
import { WeightTypes } from '@constants/entities/relationship';
import { EdgeDTO } from '@store/services/nodes/types';
import { cutNumberPeriods } from '@utils/helpers';

export type RelationshipFormSyncOpts = {
  isLastANDAuto: boolean;
  contextType: RelationContextType | null;
  parentOptions: RelationOption[];
};

/** Maps API relation DTO to RHF values (same rules as useFormReset). */
export function edgeDtoToRelationshipFormValues(
  dto: EdgeDTO,
  opts: RelationshipFormSyncOpts,
  /** PATCH/create responses often omit `description`; keep UI text instead of wiping the field. */
  descriptionFallback?: string,
): Omit<RelationshipFormValues, 'maxWeight'> {
  const {
    type,
    dependency,
    description,
    weight,
    weight_type,
    valid_status,
    meta_data,
  } = dto;

  const resolvedDescription =
    description === undefined || description === null
      ? descriptionFallback ?? ''
      : description;

  return {
    type,
    dependency,
    valid_status,
    description: resolvedDescription,
    weight: cutNumberPeriods(weight),
    weight_manual: weight_type === WeightTypes.Manual,
    isLastANDAuto: opts.isLastANDAuto,
    context: Object.fromEntries(
      opts.parentOptions.map(({ id }) => {
        const savedValue = meta_data?.controls?.[id];

        return [
          id,
          savedValue?.length ||
          opts.contextType === RelationContextType.FunctionTechnology
            ? savedValue
            : null,
        ];
      }),
    ),
  };
}
